import { SVGProps } from 'react';

export const IconInsights = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='3 3 20 20' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.9445 7.27783H19.5V12.8334'
        stroke='currentColor'
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.7222 15.0556L11.0151 15.7627C11.4056 16.1532 12.0388 16.1532 12.4293 15.7627L11.7222 15.0556ZM8.94444 12.2778L9.65155 11.5707C9.26103 11.1802 8.62786 11.1802 8.23734 11.5707L8.94444 12.2778ZM3.79289 16.0152C3.40237 16.4057 3.40237 17.0389 3.79289 17.4294C4.18342 17.8199 4.81658 17.8199 5.20711 17.4294L3.79289 16.0152ZM18.7929 6.57073L11.0151 14.3485L12.4293 15.7627L20.2071 7.98494L18.7929 6.57073ZM12.4293 14.3485L9.65155 11.5707L8.23734 12.9849L11.0151 15.7627L12.4293 14.3485ZM8.23734 11.5707L3.79289 16.0152L5.20711 17.4294L9.65155 12.9849L8.23734 11.5707Z'
        fill='currentColor'
      />
    </svg>
  );
};
